import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from "react-router-dom";
import '../../../src/custom.css'
import Header from '../PageLayout/Header';
import Footer from '../PageLayout/Footer';
import Edit_light from "../../assets/images/Edit_light.svg";
import { Select } from 'antd';
import Loader from "../loader";
import toast, { Toaster, useToasterStore } from 'react-hot-toast';
import { fetchAllSites, fetchAllTEKaController, fetchAllSiteData, fetchSubscription } from "../../Redux/Api/fetch.api";
import axios from "axios";
import * as url from "../../api/uri_helper";
import Table, { TableProps } from "antd/lib/table";
import Trash_light from "../../assets/images/Trash_light.svg";
import { Modal,Switch } from 'antd';
import Add from "../../assets/images/Add.svg";
import Layout from '../Layout';
import { Tooltip } from 'antd';
import { getallsites, deletesitesdetails } from '../../Redux/Actions/SiteActions';
import NotAuthorised from "../Authentication/NotAuthorised";
import { fetchUserRoledata } from "../../Redux/Api/fetch.api";
import { getuserroleandmenu } from '../../Redux/Actions/UsersActions';
import { useTranslation } from "react-i18next";
import Title from "../Title";
import { Breadcrumb } from "antd";
import LinkIcon from '@mui/icons-material/Link';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import QrCodeGenerator from "../TEKaController/QrCodeGenerator";
import QRCode from "qrcode";

const TekacontrollerIndex = () => {
    const { t } = useTranslation('tekaController');
    //const alldataTypes = useSelector((state) => state.allUserdata.users);
    //const roleName = alldataTypes && alldataTypes.data && alldataTypes.data.userRoleDetails[0].roleName;
   
    const { REACT_APP_DEFAULT_PAGESIZE } = process.env;
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [table, setTable] = useState([]);
    const [pageSize, setPageSize] = useState(REACT_APP_DEFAULT_PAGESIZE)
    const [options, setOptions] = useState({ pagination: { current: 1 }, pageSize: pageSize });
    const [totalIndex, setCurrentIndex] = useState()
    const [pageData, setPageData] = useState({});
    const [total, setTotal] = useState()
    let history = useHistory();
    const loggedUserId = localStorage.getItem('UserId')
    const [roleId, setRoleId] = useState(null);
    const [compName, setCompName] = useState("");
    const [userRoleData, setUserRoleData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(5)
    const showPagination = totalCount > REACT_APP_DEFAULT_PAGESIZE;
    const [dropdownChange, setDropdownChange] = useState(false);
    const [description, setDescription] = useState("")
    const [modaldescription, setModalDescription] = useState("")
    const [siteId, setSiteId] = useState(null)
    const [comingsiteId, setComingSiteId] = useState()
    const [computerName, setComputerName] = useState("");
    const [allSites, setAllSitesData] = useState([])
    const [refreshData, setRefreshData] = useState(false);
    const [subscribed, setSubscribed] = useState({});
    const [showQRCode, setShowQRCode] = useState(false);
    const [showQRModal, setShowQRModal] = useState(false);


    useEffect(() => {
        console.log('Updated subscribed state:', subscribed);
    }, [subscribed]); // This will run whenever `subscribed` changes

    useEffect(() => {
        if (roleId == 7 || roleId == 8) {
            getAllTEKaControllers();
        }
    }, [refreshData,roleId]);

    useEffect(() => {
        getUserDetails();
    }, []);

    useEffect(() => {
        setLoading(false)
        if (roleId == 7 || roleId == 8) {
            getAllSitesData();
        }
    }, [roleId])



    const getAllTEKaControllers = (pageindex = 1, pagesize = REACT_APP_DEFAULT_PAGESIZE) => {

        setLoading(true)
        fetchAllTEKaController({
            PageIndex: pageindex,
            PageSize: pageSize > REACT_APP_DEFAULT_PAGESIZE ? pageSize : pagesize,
            Description: description,
            ComputerName: compName == "" ? "" : compName,
            SiteId: siteId ? siteId : 0,
            UserId: localStorage.getItem('UserId')
        })
            .then(response => {
                //    dispatch(getallworkitems(response.data))
                console.log(response)
                setTable(response.data.data)
                setTotalCount(response.data.count);
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
        handleCancel();       
            setLoading(false)      
    }

    const getUserDetails = () => {
        fetchUserRoledata(loggedUserId)
            .then(response => {
                dispatch(getuserroleandmenu(response.data.data))
                setUserRoleData(response.data.data.userRoleDetails);
                if (response.data.data.userRoleDetails[0].roleId)
                    setRoleId(response.data.data.userRoleDetails[0].roleId);
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
    }

    const handleToggle = async (data, tekaID) => {
        // Toggle the subscription state for the specific tekaID
        const newSubscribedState = !data.isSubscribed;
        // Get user details
        const userId = localStorage.getItem('UserId');
        const subscriptionDate = new Date().toISOString();
        const subscriptionBy = 'user'; // or 'admin' based on your logic
        setTable(prevState => {
            return prevState.map(item => {
                if (item.teKaID === tekaID) {
                    return {
                        ...item,
                        isSubscribed: newSubscribedState,
                    };
                }
                return item;
            });
        });
        // Update the subscription state in the database

        fetchSubscription({
            UserId: userId,
            TekaId: tekaID,
            SubscriptionDate: subscriptionDate,
            SubscriptionBy: subscriptionBy,
            IsSubscribed: newSubscribedState
        })
            .then(response => {
                toast.success(`TEKaController ${data.description} is successfully ${newSubscribedState ? 'Subscribed' : 'Unsubscribed'}`), {
                    className: "toastSuccess",
                }
                getAllTEKaControllers()
            })
            .catch((err) => {
                toast.error('Unknown Error Occured', {
                    className: "toastSuccess",
                },);
            });
        console.log('Updated subscribed state:', subscribed);
    };

    const getAllSitesData = () => {
        setLoading(true)
        fetchAllSiteData()
            .then(response => {
                //dispatch(getallcompanies(response.data))
                setAllSitesData(response.data.data)
            })
            .catch((err) => {
                console.log("Err: ", err);
            });
        setLoading(false)
    }




    const { confirm } = Modal;
    const handleDelete = (tekaID) => {
        confirm({
            title: t("Areyousureyouwanttodeletethisrecord"),
            okText: "Yes",
            okType: 'danger',
            cancelText: "No",
            onOk() {
                deleteTEKaControllerRecord(tekaID)
            },
            onCancel() {
            },
        });
    }

    const handlePageChange = (page, newPageSize) => {
        setCurrentPage(page);
        setPageSize(newPageSize);
        getAllTEKaControllers(page, newPageSize)
    };

    const SearchControl = async () => {
       
        getAllTEKaControllers();
    }

    const handleCancel = () => {
        setDropdownChange(true);      
        setTimeout(() => {
            setDropdownChange(false);
        }, 0);
    };

    const handleSearchClear = () => {        
        setSiteId(null);
        setDescription('');
        setCompName("")
        setRefreshData(prev => !prev);
        handleCancel();
    };

    const deleteTEKaControllerRecord = async (tekaID) => {
        
        setLoading(true)
        await axios.delete(url.DELETE_TEKACONTROLLER + '/' + tekaID, {
        }).then(response => {
            
            //dispatch(deletesitesdetails(response.data))
            setTimeout(() => {
                setLoading(false)
            }, 1000)
            toast.success(t("TEKaControllerDeletedSuccessfully"), {
                className: "toastSuccess",
            },);
            getAllTEKaControllers();

        }).catch((err) => {
            console.log("Err: ", err);
        });
        setLoading(false)
    }
    const handleEdit = (tekaId) => {
        history.push('/Tekacontroller/edit/' + tekaId)
    }

    const handleChange = (pagination, sorter, current) => {
        const updatedOptions = { ...options, pagination };
        setOptions(updatedOptions);
        setPageData(updatedOptions)
    };

    const bindProject = (userRoles) => {
        return userRoles.map(x => x.name).join(", ");
    }

    const getFullDate = (date) => {
        const newDate = new Date(date);
        const returnDate = ((newDate.getMonth() > 8) ? (newDate.getMonth() + 1) : ('0' + (newDate.getMonth() + 1))) + '-' + ((newDate.getDate() > 9) ? newDate.getDate() : ('0' + newDate.getDate())) + '-' + newDate.getFullYear();
        const dateAndTime = date.split("T");
        const time = dateAndTime[1].split(":");
        const newtime = time[0] + " : " + time[1]
        const times = time[0] > 12 ? time[0] % 12 : time[0];
        const timeslatest = times < 9 ? ('0' + times) : times;
        const newtime1 = timeslatest + " : " + time[1]
        if (time[0] && time[0] >= 12) {
            return (
                //dateAndTime[0].split("-").reverse().join("-") + ", " + newtime1 + " PM "
                returnDate + ", " + newtime1 + " PM "
            );
        } else {
            return (
                //dateAndTime[0].split("-").reverse().join("-") + ", " + newtime + " AM "
                returnDate + ", " + newtime + " AM "
            );
        }
    };

    const handlePreviewQR = (record) => {       
        setComingSiteId(record.siteID)
        setComputerName(record.computerName)
        setModalDescription(record.description)
        setShowQRModal(true)
        setShowQRCode(true)                      
    }

    const handleQRModalClose = () => {
        setShowQRModal(false)
    };

    const handleDownloadQR = async (record) => {
        const siteid = record.siteID;
        const computername = record.computerName;
        const appid = 5; // or use record.appid if it's dynamic
        const qrUrl = `${url.TEKAGUI}/support?siteId=${siteid}&appID=${appid}&desktopname=${computername}`;

        try {
            const dataUrl = await QRCode.toDataURL(qrUrl);

            const link = document.createElement("a");
            link.href = dataUrl;
            link.download = `QR_${siteid}_${computername}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("QR code download failed:", error);
        }
    };



    const columns = [
        {
            title: t("SrNo"),
            dataIndex: "",
            render: (value, item, index) => (currentPage - 1) * pageSize + index + 1,
        },

        {
            title: t("TEKaID"),
            dataIndex: "teKaID",
        },

        {
            title: t("SiteName"),
            dataIndex: "siteName",
        },

        {
            title: t("Computer Name"),
            dataIndex: "computerName",
          //  className: "description",
            render: (computerName) => <Tooltip title={computerName}>{computerName}</Tooltip>,
        },

        {
            title: t("Description"),
            dataIndex: "description",
            className: "description",
            render: (description) => <Tooltip title={description}>{description}</Tooltip>,
        },

        {
            title: t("Status"),
            dataIndex: "isActive",
            render: (data) => (data ? <span> Active</span> : <span>Inactive </span>),

        },

        {
            title: t("CreatedDate"),
            dataIndex: "created",
            render: (created) => created ? getFullDate(created) : '',
        },

        {
            title: t("UpdatedDate"),
            dataIndex: "updated",
            render: (updated) => updated ? getFullDate(updated) : '',
        },

        {
            title: "QR Url",
            key: "index",
            render: (record, index) => {
                const siteid = record.siteID;
                const computername = record.computerName;
                const appid = 5; // static or dynamic

                if (!computername) return null;

                const qrUrl = `${url.TEKAGUI}/support?siteId=${siteid}&appID=${appid}&desktopname=${computername}`;

                const copyToClipboard = () => {
                    navigator.clipboard.writeText(qrUrl)
                        .then(() => {
                            alert('Link copied to clipboard!');
                        })
                        .catch(err => {
                            console.error('Failed to copy: ', err);
                        });
                };

                return (
                    <Tooltip title="Click to copy URL" overlayStyle={{ maxWidth: 'none' }}>
                        <button className="table-btn" id={index + 1} onClick={copyToClipboard}>
                            <LinkIcon style={{ color: "white", cursor: "pointer" }} />
                        </button>
                    </Tooltip>
                );
            },
        },

       

        {
            title: "Preview QR",
            key: "index",
            render: (record, index) => {
                if (!record.computerName) return null;

                return (
                    <Tooltip title={t("ClickToPreviewQR")}>
                        <button className="table-btn" id={index + 1}>
                            <RemoveRedEyeIcon
                                style={{ color: "white", cursor: "pointer" }}
                                onClick={() => handlePreviewQR(record)}
                            />
                        </button>
                    </Tooltip>
                );
            },
        },


        {
            title: "Download QR",
            key: "index",
            render: (record, index) => {
                if (!record.computerName) return null;

                return (
                    <Tooltip title={t("ClickToDownloadQR")}>
                        <button
                            className="table-btn"
                            id={index + 1}
                            onClick={() => handleDownloadQR(record)}
                        >
                            <QrCode2Icon style={{ color: "white", cursor: "pointer" }} />
                        </button>
                    </Tooltip>
                );
            },
        },

         //{
         //    title: t("SubscribedDate"),
         //    dataIndex: "",
         //    render: (data, subscriptionDate) => data.subscriptionDate && data.isSubscribed ? getFullDate(data.subscriptionDate) : '',
         //},
       
        // Render the 'Subscribed' column
        //{
        //    title: t("Subscribed"),
        //    dataIndex: "",
        //    render: (data, tekaID) => (
        //        <>
        //            <Switch
        //                id="subscribed"
        //                className="alarm-toggle ms-2 subscribe-toggle"
        //                checked={data.isSubscribed || false} // Use state specific to each tekaID
        //                onChange={() => handleToggle(data, data.teKaID)}
        //            />
        //        </>
        //    ),
       // },

        {
            title: t("Action"),
            className: "sitebuttons",
            dataIndex: "",
            render: (data, tekaID) => (<>
                <ul className="list-inline">
                    <li className="list-inline-item mr-0">
                <button className="table-btn" >
                <img src={Edit_light} onClick={() => handleEdit(data.teKaID)}></img>
                        </button>
                    </li>
                    <li className="list-inline-item mr-0">
                <button className="table-btn" >
                    <img src={Trash_light} onClick={() => handleDelete(data.teKaID)}></img>
                        </button>
                    </li>
                    </ul>
                </>)
        },
    ]
    return (
        <div>
            <Title title="TekaController"></Title>
            {roleId == null ? <Loader /> : roleId && roleId != 7 && roleId && roleId != 8 ? <NotAuthorised></NotAuthorised> :
                <>
                    {loading ? <Loader /> : ''}
                    <Layout>
                        <section className="Company_section common ">
                            <Toaster />
                            <div className="container site-container">
                                <Breadcrumb style={{ margin: '20px 0 0 0', padding: '0px' }}
                                    itemRender={(route, params, routes, paths) => (
                                        route.path ? (
                                            <Link to={route.path}>
                                                {route.breadcrumbName}
                                            </Link>
                                        ) : (
                                            <span>{route.breadcrumbName}</span>
                                        )
                                    )}

                                    items={[
                                        {
                                            breadcrumbName: 'Dashboard',
                                            path: '/Dashboard',
                                        },
                                        {
                                            breadcrumbName: 'TekaController',
                                            path: '',
                                        }
                                    ]}
                                />

                                <div className="mt-4 w-100 position-relative tekacontroller-filter wk-select">
                                    <div className="tekacontroller-head d-flex">
                                        <h4 className="m-0">{t("TEKaController")}</h4>
                                        <div className="dropdown flex1">
                                            <button
                                                className={[
                                                    "filter-btn dropdown-toggle btn d-flex align-items-center",
                                                    dropdownChange === true ? "hide" : "",
                                                ].join(" ")}
                                                type="button"
                                                id="dropdownFilterMenuButton1"
                                                data-bs-toggle="dropdown"
                                                data-bs-auto-close="false"
                                                aria-expanded="false"
                                            >
                                                <span>
                                                    <img src={'https://tekalogbeta.azurewebsites.net/static/media/search-ico-lite.c9c235ab7706d6c030741d0f56f56cc4.svg'} ></img> {t("Filter")}
                                                </span>
                                            </button>
                                            <ul
                                                className={[
                                                    "dropdown-menu entries-dropdown-search",
                                                    dropdownChange === true ? "hide" : "",
                                                ].join(" ")}
                                                aria-labelledby="dropdownMenuButton1"
                                            >
                                                <div className="row g-3">
                                                    <div className="col-md-6">
                                                        <div className="search--tracking-col">
                                                            <label class="form-label">{t("Description")}</label>
                                                            <input
                                                                className="form-control"
                                                                placeholder={t("EnterDescription")}
                                                                type="text"
                                                                value={description}
                                                                onChange={(e) => {
                                                                    const inputText = e.target.value;
                                                                    setDescription(inputText);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label> {t("Site")} </label>
                                                            <select className="form-select mb-0 flex-grow-1 filter-select wk-select" name="roles" aria-label=".form-select-lg example"
                                                                value={siteId}
                                                                key={siteId}

                                                                onChange={(e) => {
                                                                    // setAppId(e.target.value)
                                                                    if (e.target.value == "Select Site") {
                                                                        setSiteId(null)

                                                                    }
                                                                    else {
                                                                        setSiteId(e.target.value)
                                                                    }

                                                                }}
                                                            >
                                                                <option selected="">{t("SelectSite")}</option>
                                                                {
                                                                    allSites && allSites.map(site =>
                                                                        <option key={site.siteId} value={site.siteId}>
                                                                            {site.siteName} </option>
                                                                    )
                                                                }
                                                            </select>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <div className="search--asn-col">
                                                            <label class="form-label">Computer Name</label>
                                                            <input
                                                                className="form-control"
                                                                placeholder={t("EnterComputerName")}
                                                                type="text"
                                                                value={compName}
                                                                onChange={(e) => {
                                                                    const inputText = e.target.value.trimLeft();
                                                                    const cleanedText = inputText.replace(/[^a-zA-Z0-9\s]/g, '');
                                                                    setCompName(cleanedText);
                                                                    // setSiteName(e.target.value.replace(/\s{2}/g, ''));
                                                                }}
                                                            />
                                                        </div>
                                                    </div>






                                                    <div className="col-md-12 d-flex justify-content-end mt-3">
                                                        {description != "" || siteId != null || compName != ""?
                                                            <button
                                                                className="btn btn-primary ms-auto "
                                                                onClick={SearchControl}
                                                            >
                                                                {t("Search")}
                                                            </button> :

                                                            <button
                                                                className="btn btn-primary ms-auto "
                                                                onClick={SearchControl}
                                                                disabled
                                                            >
                                                                {t("Search")}
                                                            </button>
                                                        }
                                                        <button
                                                            className="btn btn-bordered pe-3 ps-3 ms-2"
                                                            onClick={handleCancel}
                                                        >
                                                            {t("Cancel")}
                                                        </button>
                                                        <button
                                                            className="btn btn-bordered pe-3 ps-3 ms-2"
                                                            onClick={handleSearchClear}
                                                        >
                                                            {t("Reset")}
                                                        </button>
                                                    </div>
                                                </div>
                                            </ul>
                                        </div>
                                    </div>                                    
                                    <div className="ml-auto">
                                        <Link className="btn btn-primary d-flex align-items-center btn-new" to="/Tekacontroller/Add"><img src={Add}></img><span>{t("AddTEKaController")}</span></Link>
                                    </div>
                                </div>
                                <div className="Viewer-table index--table position-relative common-table mb-4">

                                    <Table
                                        className='table-responsive antd--detail-table1'
                                        columns={columns}
                                        dataSource={table}
                                        pagination={showPagination ? {
                                            total: totalCount,
                                            pageSize: pageSize,
                                            current: currentPage,
                                            showSizeChanger: true,
                                            onChange: handlePageChange,
                                            pageSizeOptions: ["50", "100"],
                                        } : false}

                                    />
                                </div>
                            </div>
                        </section>
                    </Layout >
                    <Modal
                        title={
                            <div className="modal-title"></div>
                        }
                        visible={showQRModal}
                        onCancel={handleQRModalClose}
                        footer={null}
                        width={600}
                        bodyStyle={{ height: 400, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                    >
                        <div className="text-center">
                            <h4 style={{ marginBottom: '1rem' }}>{modaldescription}</h4>
                            < QrCodeGenerator siteid={comingsiteId} appid={5} computername={computerName} isshow={true} />
                        </div>                                                                                    
                    </Modal>
                </>
            }
        </div>
    )
}
export default connect()(TekacontrollerIndex);

